export default (props, vars) => props?.['size'] || '25px';
